<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page"> <div class="bb-page-shell">
<!-- HEADER -->
<div class="bb-page-header">
  <div class="bb-inline-flex bb-items-center bb-gap-16">


    <div class="bb-page-title-block">
      <span class="bb-eyebrow">{{ 'fingerprint' | transloco }}</span>
      <h2 class="bb-page-title">{{ 'fingerprint' | transloco }}</h2>
    </div>
  </div>

  <div class="bb-header-actions noPrint">

    <!-- Check In -->
    <button
      class="bb-btn bb-btn-primary"
      *ngIf="!hasCheckedIn"
      (click)="getLocationAndCheck('in')"
      [disabled]="!canCheckIn"
    >
      {{ 'check in' | transloco }}
    </button>

    <!-- Check Out -->
    <button
      class="bb-btn bb-btn-danger"
      *ngIf="hasCheckedIn"
      (click)="getLocationAndCheck('out')"
      [disabled]="!canCheckIn || hasCheckedOut"
    >
      {{ 'check out' | transloco }}
    </button>

    <!-- Scan QR -->
    <button
      class="bb-btn bb-btn-outline"
      *ngIf="canCheckIn"
      (click)="scanMode = !scanMode"
    >
      {{ 'scan QR' | transloco }}
    </button>

    <!-- Admin Options -->
    <button
      *ngIf="isAdmin"
      class="bb-btn bb-btn-secondary"
      (click)="QrOption = !QrOption"
    >
      {{ "options" | transloco }}
    </button>

  </div>
</div>

<!-- QR OPTIONS -->
<div *ngIf="QrOption" class="bb-card bb-p-20 bb-mb-16">

  <button *ngIf="isAdmin" class="bb-btn bb-btn-primary bb-mb-16" (click)="generateQr()">
    {{ 'Create QR Code' | transloco }}
  </button>

  <div class="bb-grid bb-gap-16">

    <div *ngFor="let qr of qrList" class="bb-card bb-p-16">

      <div class="bb-flex bb-justify-center bb-mb-16">
        <img [src]="fixImageUrl(qr.qr_url)" class="bb-preview-img">
      </div>

      <div class="bb-flex bb-items-center bb-justify-center bb-gap-12 bb-wrap">

        <button class="bb-btn bb-btn-outline bb-btn-sm" (click)="downloadQr(fixImageUrl(qr.qr_url))">
          {{ 'Download QR' | transloco }}
        </button>

        <button class="bb-btn bb-btn-danger bb-btn-sm" (click)="deleteQr(qr.id)">
          {{ 'Delete' | transloco }}
        </button>

      </div>

    </div>

  </div>

</div>

<!-- SCANNER -->
<div *ngIf="scanMode" class="bb-card bb-p-20 bb-text-center bb-mb-16">

  <zxing-scanner [formats]="allowedFormats" (scanSuccess)="onCodeResult($event)">
  </zxing-scanner>

</div>

<!-- FILTERS -->
<div class="bb-filter-card noPrint">

  <div class="bb-form-grid">

    <!-- Month Filter -->
    <div class="bb-field">

      <label class="bb-label">{{ "bymonth" | transloco }}</label>

      <div [ngClass]="isSubAdmin ? 'row g-2' : 'bb-flex bb-gap-8'">

        <div class="bb-select-wrap" [ngClass]="isSubAdmin ? 'col-6' : 'bb-w-100'">
          <select class="bb-select" [(ngModel)]="selectedYear">

            <option *ngFor="let year of years" [value]="year">
              {{ year }}
            </option>

          </select>
        </div>

        <div class="bb-select-wrap" [ngClass]="isSubAdmin ? 'col-6' : 'bb-w-100'">
          <select class="bb-select" [(ngModel)]="selectedMonth" (change)="loadAttendance()">

            <option *ngFor="let month of months" [value]="month.value">
              {{ isAr ? month.name_ar : month.name_en }}
            </option>

          </select>
        </div>

      </div>

    </div>

    <!-- Users Filter -->
    <div class="bb-field" *ngIf="hasaccess && !isSubAdmin">

      <label class="bb-label">{{ "Users" | transloco }}</label>

      <div class="bb-select-wrap">
        <select #userSelect class="bb-select" (change)="userFilter(userSelect.value)">

          <option *ngFor="let el of allUsers" [value]="el.id">
            {{ el.first_name }} {{ el.last_name }}
          </option>

        </select>
      </div>

    </div>

  </div>

</div>

<!-- TABLE -->
<div class="bb-card bb-p-20">

  <div class="bb-table-scroll">

    <table class="bb-table table-custom">

      <thead>

        <tr class="mat-header-row-custom">

          <th class="mat-header-cell-custom">{{ "Date" | transloco }}</th>

          <th class="mat-header-cell-custom">{{ 'check in' | transloco }}</th>

          <th class="mat-header-cell-custom">{{ 'check out' | transloco }}</th>

          <th class="mat-header-cell-custom" *ngIf="isAdmin">{{ 'device' | transloco }}</th>

          <th class="mat-header-cell-custom" *ngIf="isAdmin">{{ 'location' | transloco }}</th>

          <th class="mat-header-cell-custom" *ngIf="isAdmin">{{ 'server time' | transloco }}</th>

        </tr>

      </thead>

      <tbody>

        <tr *ngFor="let record of attendanceData" class="mat-row-custom">

          <!-- DATE -->
          <td class="mat-cell-custom">

            <div class="bb-font-bold bb-text-navy">
              {{ record.date }}
            </div>

            <div class="bb-text-muted bb-font-semibold bb-mt-8">
              {{ 'workingtime' | transloco }} :
              {{ calculateDiff(
              record.check_in_device_time,
              record.check_out_device_time
              ) }}
            </div>

          </td>

          <!-- CHECK IN -->
          <td class="mat-cell-custom">

            <span class="bb-badge bb-badge-success">
              {{ record.check_in_device_time || '-' }}
            </span>

          </td>

          <!-- CHECK OUT -->
          <td class="mat-cell-custom">

            <span class="bb-badge bb-badge-warning">
              {{ record.check_out_device_time || '-' }}
            </span>

          </td>

          <!-- DEVICE -->
          <td *ngIf="isAdmin" class="mat-cell-custom">

            <div class="bb-font-semibold bb-text-navy">
              {{ record.ip_address || '-' }}
            </div>

            <div class="bb-text-muted bb-font-semibold bb-mt-8">
              {{ extractDeviceInfo(record.device_info) || '-' }}
            </div>

          </td>

          <!-- LOCATION -->
          <td *ngIf="isAdmin" class="mat-cell-custom">

            <div class="bb-grid bb-gap-12">

              <div class="bb-grid bb-gap-4">

                <span class="bb-badge bb-badge-soft-blue">
                  {{ 'check in' | transloco }}
                </span>

                <a
                  class="bb-link-action"
                  target="_blank"
                  href="https://www.google.com/maps?q={{ record.check_in_latitude }},{{ record.check_in_longitude }}"
                >

                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 21C12 21 5 14.5 5 9.5C5 5.9 8.1 3 12 3C15.9 3 19 5.9 19 9.5C19 14.5 12 21 12 21Z"
                      stroke="#2A7DE1" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                    <circle cx="12" cy="9.5" r="2.5" stroke="#2A7DE1" stroke-width="2.5" />
                  </svg>
                  {{ 'map location' | transloco }}

                </a>

              </div>

              <div class="bb-grid bb-gap-4">

                <span class="bb-badge bb-badge-soft-cyan">
                  {{ 'check out' | transloco }}
                </span>

                <a
                  class="bb-link-action"
                  target="_blank"
                  href="https://www.google.com/maps?q={{ record.check_out_latitude }},{{ record.check_out_longitude }}"
                >

                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 21C12 21 5 14.5 5 9.5C5 5.9 8.1 3 12 3C15.9 3 19 5.9 19 9.5C19 14.5 12 21 12 21Z"
                      stroke="#2A7DE1" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                    <circle cx="12" cy="9.5" r="2.5" stroke="#2A7DE1" stroke-width="2.5" />
                  </svg>
                  {{ 'map location' | transloco }}

                </a>

              </div>

              <span
                class="bb-badge"
                [ngClass]="{
                  'bb-badge-success': record.location_access_denied == 0,
                  'bb-badge-danger': record.location_access_denied == 1
                }"
              >

                {{ record.location_access_denied
                ? ('locationrejected' | transloco)
                : ('access' | transloco) }}

              </span>

            </div>

          </td>

          <!-- SERVER TIME -->
          <td *ngIf="isAdmin" class="mat-cell-custom">

            <div class="bb-grid bb-gap-12">

              <div>

                <span class="bb-badge bb-badge-soft-blue">
                  {{ 'check in' | transloco }}
                </span>

                <div class="bb-mt-8 bb-font-semibold">
                  {{ record.check_in_server_time || '-' }}
                </div>

              </div>

              <div>

                <span class="bb-badge bb-badge-soft-cyan">
                  {{ 'check out' | transloco }}
                </span>

                <div class="bb-mt-8 bb-font-semibold">
                  {{ record.check_out_server_time || '-' }}
                </div>

              </div>

            </div>

          </td>

        </tr>

      </tbody>

    </table>

  </div>

</div>
</div> </section>
